// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-delivery-adress-wrapper {
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  background-color: var(--color-button-text);
  cursor: auto;
}
.checkout-delivery-adress-wrapper .divider {
  border-color: #dce2f0;
  margin: var(--spacing-small) 0;
}
.checkout-delivery-adress-wrapper .checkout-delivery-adress-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  margin-bottom: var(--spacing-small);
}
.checkout-delivery-adress-wrapper .checkout-delivery-adress-title .vert-icon {
  cursor: auto;
}
.checkout-delivery-adress-wrapper .checkout-delivery-adress-title .vert-icon svg {
  width: 18px;
  height: 18px;
  fill: var(--color-neutral-dark-darker);
}
.checkout-delivery-adress-wrapper .checkout-delivery-adress-title .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 24px !important;
  margin: 0;
  text-align: left;
  cursor: auto;
}
.checkout-delivery-adress-wrapper .vert-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.checkout-delivery-adress-wrapper .vert-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.checkout-delivery-adress-wrapper .add-addres-button {
  color: var(--color-neutral-light, #b9bec9) !important;
}
.checkout-delivery-adress-wrapper .add-addres-button .vert-icon svg {
  fill: var(--color-neutral-light);
}
.checkout-delivery-adress-wrapper .add-addres-button span {
  color: var(--color-neutral-light, #b9bec9) !important;
}
.checkout-delivery-adress-wrapper .add-addres-button:hover {
  color: var(--color-neutral-dark-lighter) !important;
}
.checkout-delivery-adress-wrapper .add-addres-button:hover .vert-icon svg {
  fill: var(--color-neutral-dark-lighter) !important;
}
.checkout-delivery-adress-wrapper .add-addres-button:hover span {
  color: var(--color-neutral-dark-lighter) !important;
}
.checkout-delivery-adress-wrapper .content-buttons {
  display: block;
}
@media screen and (max-width: 768px) {
  .checkout-delivery-adress-wrapper {
    padding: var(--spacing-small);
    background-color: var(--color-button-text);
  }
  .checkout-delivery-adress-content .content-buttons {
    display: flex !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Checkout/CheckoutDeliveryAddressStyles.less"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,wDAAA;EACA,gDAAA;EACA,0CAAA;EACA,YAAA;AAAF;AALA;EAQI,qBAAA;EACA,8BAAA;AAAJ;AATA;EAaI,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mCAAA;AADJ;AAfA;EAmBM,YAAA;AADN;AAlBA;EAqBQ,WAAA;EACA,YAAA;EACA,sCAAA;AAAR;AAvBA;EA4BM,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAFN;AA/BA;EAuCI,0BAAA;EACA,2BAAA;AALJ;AAnCA;EA2CI,yBAAA;EACA,0BAAA;AALJ;AAvCA;EAgDI,qDAAA;AANJ;AA1CA;EAkDM,gCAAA;AALN;AA7CA;EAqDM,qDAAA;AALN;AAOI;EACE,mDAAA;AALN;AAII;EAGI,kDAAA;AAJR;AACI;EAMI,mDAAA;AAJR;AAzDA;EAkEI,cAAA;AANJ;AAWA;EACE;IACE,6BAAA;IACA,0CAAA;EATF;EAWA;IAEI,wBAAA;EAVJ;AACF","sourcesContent":["// DESKTOP\n.checkout-delivery-adress-wrapper {\n  padding: var(--spacing-regular);\n  border-radius: var(--border-radius-secondary) !important;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n  background-color: var(--color-button-text);\n  cursor: auto;\n\n  .divider {\n    border-color: #dce2f0;\n    margin: var(--spacing-small) 0;\n  }\n\n  .checkout-delivery-adress-title {\n    display: flex;\n    align-items: center;\n    gap: var(--spacing-extra-small);\n    margin-bottom: var(--spacing-small);\n\n    .vert-icon {\n      cursor: auto;\n      svg {\n        width: 18px;\n        height: 18px;\n        fill: var(--color-neutral-dark-darker);\n      }\n    }\n\n    .vert-title {\n      font-size: var(--font-medium);\n      font-weight: 600;\n      line-height: 24px !important;\n      margin: 0;\n      text-align: left;\n      cursor: auto;\n    }\n  }\n\n  // flex-wrap: wrap;\n  .vert-col {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .vert-row {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .add-addres-button {\n    color: var(--color-neutral-light, #b9bec9) !important;\n    .vert-icon svg {\n      fill: var(--color-neutral-light);\n    }\n    span {\n      color: var(--color-neutral-light, #b9bec9) !important;\n    }\n    &:hover {\n      color: var(--color-neutral-dark-lighter) !important;\n      .vert-icon svg {\n        fill: var(--color-neutral-dark-lighter) !important;\n      }\n      span {\n        color: var(--color-neutral-dark-lighter) !important;\n      }\n    }\n  }\n  .content-buttons {\n    display: block;\n  }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .checkout-delivery-adress-wrapper {\n    padding: var(--spacing-small);\n    background-color: var(--color-button-text);\n  }\n  .checkout-delivery-adress-content {\n    .content-buttons {\n      display: flex !important;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
